import { useTranslation } from "react-i18next";
import shopifyLogo from "../../Images/Owision/shopifyHex.png";
import stripeLogo from "../../Images/Owision/stripehex.png";
import checkoutLogo from "../../Images/Owision/cchex.png";
import invoiceEditor from "../../Images/Owision/invoiceEditor.png";
import synctosheetLogo from "../../Images/Owision/synctosheetLogo.png";
import notifySync from "../../Images/Owision/notifySync.png";
import reviewHub from "../../Images/Owision/reviewHub.png";
import mondayHex from "../../Images/Owision/mondayHex.png";
import mirrorstatusHex from "../../Images/Owision/mirrorHex.png";

const ShopifyHeroSection = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="flex flex-col items-center justify-center h-[70vh] md:h-[100vh] text-white !px-5 md:!px-24 text-center  !w-[100%] ">
        <h1 className="text-[26px] md:text-[3rem] font-semibold">
          {t("shopifyStripe.hero.title")}
        </h1>
        <h3 className="text-[12px] md:text-[2rem] md:!px-42">
          {t("shopifyStripe.hero.description")}
        </h3>
        <div className="flex md:gap-42 gap-10 !my-[2rem] md:!mt-34">
          {/* monday */}
          <div className="md:flex ">
            <div className="">
              <img className="h-[3rem] md:h-[6rem]" src={mirrorstatusHex}></img>
            </div>
            <div className="">
              <img className="h-[3rem] md:h-[6rem]" src={mondayHex}></img>
            </div>
          </div>

          {/* shopify */}
          <div className="relative">
            <div className="md:absolute  md:top-[-75%]  md:left-[-60%]">
              <img className="h-[3rem] md:h-[6rem]" src={checkoutLogo} alt="CC Logo" />
            </div>
            <div className="">
              <img className="h-[3rem] md:!h-[6rem]" src={shopifyLogo} alt="Shopify Logo" />
            </div>
            <div className="absolute top-[90%]  left-[-60%]  md:top-[80%]  md:left-[-60%]">
              <img className="h-[3rem] md:h-[6rem]" src={reviewHub} alt="Review Logo" />
            </div>
          </div>

          {/* stripe */}
          <div className="flex !mt-5 md:!mt-0 relative">
            <div className="absolute top-[-50%] right-[25%]  md:left-[-35%]  md:top-[-70%]">
              <img className="h-[3rem] md:h-[6rem]" src={notifySync} alt="Shopify Logo" />
            </div>
            <div>
              <img className="h-[3rem] md:!h-[6rem]" src={stripeLogo} alt="Stripe Logo" />
            </div>
            <div className="absolute top-[65%] left-[-15%] md:top-[70%]  md:left-[-35%]">
              <img className="h-[3rem] md:h-[6rem]" src={invoiceEditor} alt="Invoice Logo" />
            </div>
            <div className="flex flex-row">
              <img className="h-[3rem] md:h-[6rem]" src={synctosheetLogo} alt="Synctosheet Logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopifyHeroSection;
